import {
  Component,
  inject,
  Renderer2,
  DOCUMENT,
  ChangeDetectionStrategy,
} from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  PublicToolbarConfig,
  PublicToolbarService,
} from '../../services/public-toolbar.service';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PressableComponent } from './components/pressable/pressable.component';
import { RouterLink } from '@angular/router';
import { BurgerComponent } from './components/burger/burger.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { LanguageSwitchComponent } from '../language-switch/language-switch.component';

/** Login, sign-up and password pages: no footer. */
export const AUTH_ROUTE =
  /^\/(login|signup|password-forget|reset-password)(\/|\?|#|;|$)/;

@Component({
  selector: 'app-public-toolbar',
  templateUrl: './public-toolbar.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatToolbar,
    NavigationComponent,
    PressableComponent,
    RouterLink,
    BurgerComponent,
    DropdownComponent,
    LanguageSwitchComponent,
    AsyncPipe,
  ],
})
export class PublicToolbarComponent {
  config$: Observable<PublicToolbarConfig>;

  baseUrl = environment.homepageBaseUrl;
  mobileMenuIsOpen = false;

  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);

  constructor() {
    const toolbarService = inject(PublicToolbarService);

    this.config$ = toolbarService.config$;
  }

  toggleMobileMenu(isOpen: boolean) {
    this.mobileMenuIsOpen = isOpen;

    if (!isOpen) {
      this.renderer.removeClass(this.document.body, 'menu-is-open');
    } else {
      this.renderer.addClass(this.document.body, 'menu-is-open');
    }
  }

  closeMobileMenu() {
    this.mobileMenuIsOpen = false;
    this.renderer.removeClass(this.document.body, 'menu-is-open');
  }
}
